import dynamic from 'next/dynamic';
import { FormField } from '../FormField/FormField';
const DatepickerDynamic = dynamic(async () => {
  const result = await import('../Datepicker/Datepicker');
  return result.Datepicker;
}, {
  loading: () => <FormField as="input" disabled />,
  ssr: false
});
export { DatepickerDynamic };